class CollectionSidebar extends HTMLElement {
  constructor() {
    super();
    this.init();
    this.setupLocationFiltering();
  }

  init() {
    this.handleAccordion('.collection-sidebar__item', '.collection-sidebar__link', '.collection-sidebar__submenu');
    this.handleAccordion('.collection-sidebar__subitem', '.collection-sidebar__sublink', '.collection-sidebar__sub-submenu');
  }

  setupLocationFiltering() {
    // Listen for location change events
    window.addEventListener('locationChanged', (event) => {
      this.updateCollectionLinks(event.detail.location);
    });
    
    // Listen for location cleared events
    window.addEventListener('locationCleared', (event) => {
      this.clearLocationFilters();
    });
    
    this.checkAndUpdateLinks();
  }

  checkAndUpdateLinks() {
    const locationData = window.locationFilterUtils.getStoredLocationData();
    if (locationData && locationData.location) {
      this.updateCollectionLinks(locationData.location);
    }
  }

  updateCollectionLinks(selectedLocation) {
    window.locationFilterUtils.updateCollectionLinks(selectedLocation, 'Collection Sidebar');
  }

  /**
   * Clear location filters from all collection links
   */
  clearLocationFilters() {
    window.locationFilterUtils.clearLocationFilters('Collection Sidebar');
  }

  handleAccordion(containerSelector, linkSelector, submenuSelector) {
    const items = this.querySelectorAll(containerSelector);

    items.forEach(item => {
      const link = item.querySelector(linkSelector);
      const submenu = item.querySelector(submenuSelector);

      if (submenu) {
        if (link.classList.contains('active')) {
          submenu.style.display = 'block';
          link.classList.add('open');
        } else {
          submenu.style.display = 'none';
        }

        link.addEventListener('click', (e) => {
          if (submenu) {
            e.preventDefault();
            const isOpen = submenu.style.display === 'block';

            items.forEach(siblingItem => {
              if (siblingItem !== item) {
                const siblingSubmenu = siblingItem.querySelector(submenuSelector);
                if (siblingSubmenu) {
                  siblingSubmenu.style.display = 'none';
                  siblingItem.querySelector(linkSelector).classList.remove('open');
                }
              }
            });

            submenu.style.display = isOpen ? 'none' : 'block';
            link.classList.toggle('open', !isOpen);
          }
        });
      }
    });
  }
}

customElements.define('collection-sidebar', CollectionSidebar); 